export default "__VITE_ASSET__B8hUY4V4__"